import { render, staticRenderFns } from "./MealItemsDetailsDialog.vue?vue&type=template&id=5ed697ba&scoped=true"
import script from "./MealItemsDetailsDialog.vue?vue&type=script&lang=js"
export * from "./MealItemsDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./MealItemsDetailsDialog.vue?vue&type=style&index=0&id=5ed697ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed697ba",
  null
  
)

export default component.exports